<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛考务管理</el-breadcrumb-item>
      <el-breadcrumb-item>区域决选</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 信息筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="1">
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择赛季"
                style="width: 100%"
                @change="seasonHandleChange"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                placeholder="请选择"
                @visible-change="changeRaceScheduleValue"
                style="width: 100%"
                v-model="queryForm.raceSchedule"
                clearable
              >
                <el-option
                  v-for="item in raceScheduleList"
                  :key="item.id"
                  :label="item.scheduleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="6">
            <el-form-item label="学校省市区" prop="schoolArea">
              <el-cascader
                placeholder="请选择"
                clearable
                v-model="queryForm.schoolArea"
                ref="schoolAreaRef"
                :options="areasData"
                style="width: 100%"
                :props="{
                  expandTrigger: 'hover',
                  label: 'name',
                  value: 'id',
                  children: 'areas',
                }"
                @change="provincesHandleChange"
              ></el-cascader>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="学校" prop="schoolId">
              <!-- <el-select
                ref="schoolSelectRef"
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.schoolId"
                clearable
                filterable
              >
                <el-option
                  v-for="item in provincesSchoolList"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id"
                ></el-option>
              </el-select> -->
              <el-select
                v-model="queryForm.schoolId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in schools"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="参赛方式" prop="participation">
              <el-select
                placeholder="请选择"
                v-model="queryForm.participation"
                style="width: 100%"
              >
                <el-option
                  v-for="item in participation_way"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="学生姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="组别" prop="enrollmentLevel">
              <el-select
                placeholder="请选择"
                v-model="queryForm.enrollmentLevel"
                style="width: 100%"
              >
                <el-option
                  v-for="item in dict_Group"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否晋级" prop="promotion">
              <el-select
                placeholder="请选择"
                v-model="queryForm.promotion"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in isPromotion"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="赛区" prop="districtIds">
              <el-select
                placeholder="请选择"
                style="width: 100%;"
                v-model="queryForm.districtIds"
                clearable
                multiple
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6" v-if="scoreTypeActiveName === 'off-line'">
            <el-form-item label="成绩查询码" prop="scoreCode">
              <el-input
                v-model="queryForm.scoreCode"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row :gutter="0"> </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="getDataList(scoreTypeActiveName, 'search')"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 信息列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">成绩信息列表</span>
        </el-col>
        <el-col :span="15">
          <div style="text-align: right">
            <el-button
              type="primary"
              plain
              @click="exportFn"
              >导出成绩</el-button
            >
            <el-button
              type="primary"
              plain
              @click="importScoreDialogVisible = true"
              >导入晋级名单</el-button
            >
            <!-- <el-button
              type="primary"
              v-if="scoreTypeActiveName === 'off-line'"
              @click="scoreQueryCodeDialogVisible = true"
              >批量生成成绩查询码</el-button
            > -->
            <el-button type="primary" @click="setPassDialogVisible = true"
              >批量设置晋级</el-button
            >
            <!-- <el-button
              type="primary"
              @click="downLoadScoreSearchCode"
              v-if="scoreTypeActiveName === 'off-line'"
              >导出成绩查询码</el-button
            > -->
          </div>
        </el-col>
      </el-row>
      <el-tabs
        type="border-card"
        v-model="scoreTypeActiveName"
        @tab-click="scoreTypeChengeClick"
      >
        <!-- 2022~2023复选无线上答题形式，比赛形式为表单答题+现场答题（有裁判系统） -->
        <el-tab-pane v-if="queryForm.season !== '2022~2023'" label="线上成绩" name="on-line">
          <!-- <div class="page-desc">小程序答题成绩</div> -->
          <el-table
            header-cell-class-name="tableHeaderStyle"
            :data="dataList"
            border
            stripe
          >
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="赛区" prop="districtName"></el-table-column>
            <el-table-column label="姓名" prop="userName"></el-table-column>
            <el-table-column label="手机号" prop="phone"></el-table-column>
            <el-table-column label="学校" prop="schoolName"></el-table-column>
            <el-table-column
              label="组别"
              prop="enrollmentLevel"
              :formatter="groupFormatter"
            ></el-table-column>
            <el-table-column
              label="年级"
              prop="grade"
              :formatter="gradeFormatter"
            ></el-table-column>
            <el-table-column label="复赛成绩" prop="score"></el-table-column>
            <!-- <el-table-column label="答题次数" prop="answerNum"></el-table-column> -->
            <el-table-column label="晋级状态" prop="expectedTime">
              <template slot-scope="scope">
                <el-tag
                  type="danger"
                  v-if="scope.row.promotion === 2"
                  size="mini"
                  >未晋级</el-tag
                >
                <el-tag
                  type="success"
                  v-else-if="scope.row.promotion === 1"
                  size="mini"
                  >已晋级</el-tag
                >
                <el-tag
                  type="warning"
                  v-else-if="!scope.row.promotion || scope.row.promotion === 0"
                  size="mini"
                  >未设置</el-tag
                >
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140px">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="showEditDialog(scope.row)"
                  >设置国赛晋级</el-button
                >
                <!-- <el-button
                  type="text"
                  size="small"
                  @click="showViewDetails(scope.row)"
                  >查看详情</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="线下成绩" name="off-line">
          <div v-if="queryForm.season === '2022~2023'" class="page-desc">
            2022~2023赛季：Round 1形式为小程序表单答题；Round 2和Round 3形式为1V1现场发音比赛。复赛成绩为三轮比赛的综合成绩。
            <span class="text-btn" @click="handleToFormScores">查看Round 1表单答题成绩详情</span>
          </div>
          <el-table
            header-cell-class-name="tableHeaderStyle"
            :data="dataListOffLine"
            border
            stripe
          >
            <el-table-column label="序号" type="index"></el-table-column>
            <!-- <el-table-column label="省市区" prop="provence">
              <template slot-scope="scope">
                <span
                  >{{ scope.row.province }}-{{ scope.row.city }}-{{ scope.row.area }}</span
                >
              </template>
            </el-table-column> -->
            <el-table-column
              label="赛季"
              prop="season"
            ></el-table-column>
            <el-table-column label="赛区" prop="districtName"></el-table-column>
            <el-table-column
              label="学校"
              prop="schoolName"
              width="140"
            ></el-table-column>
            <el-table-column label="姓名" prop="userName"></el-table-column>
            <!-- <el-table-column label="性别" prop="scoreSex" width="50px"></el-table-column> -->
            <el-table-column
              label="手机号"
              prop="phone"
              width="100"
            ></el-table-column>
            <el-table-column
              label="组别"
              :formatter="gradeGroupFormatter"
              width="130"
            ></el-table-column>
            <el-table-column
              label="年级"
              prop="grade"
              :formatter="gradeFormatter2"
            ></el-table-column>

            <!-- <el-table-column label="班级" prop="scoreClass"></el-table-column> -->
            <el-table-column label="复赛成绩" prop="roundTotal" align="center">
              <template slot-scope="scope">
                <!-- <el-tag v-if="scope.row.scores === undefined || scope.row.scores === null" type="info"  size="mini">未参赛</el-tag>
                <span v-else>{{ scope.row.scores }}</span> -->
                <span class="score">{{ scoreFormat(scope.row.roundTotal) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Round 1" prop="roundOne" align="center" v-if="queryForm.season === '2022~2023'">
              <template slot-scope="scope">
                {{ scoreFormat(scope.row.roundOne) }}
              </template>
            </el-table-column>
            <el-table-column label="Round 2" prop="roundTwo" align="center" v-if="queryForm.season === '2022~2023'">
              <template slot-scope="scope">
                {{ scoreFormat(scope.row.roundTwo) }}
              </template>
            </el-table-column>
            <el-table-column label="Round 3" prop="roundThree" align="center" v-if="queryForm.season === '2022~2023'">
              <template slot-scope="scope">
                {{ scoreFormat(scope.row.roundThree) }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="成绩查询码" prop="scoreCode"></el-table-column> -->
            <el-table-column label="晋级状态" prop="promotion" align="center">
              <template slot-scope="scope">
                <el-tag type="danger" size="mini" v-if="scope.row.promotion === 2">未晋级</el-tag>
                <el-tag type="success" size="mini" v-else-if="scope.row.promotion === 1">已晋级</el-tag>
                <el-tag type="warning" size="mini" v-else-if="!scope.row.promotion || scope.row.promotion === 0">未设置</el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  size="small"
                  @click="showEditOffLineDialog(scope.row)"
                  >晋级修改</el-button
                >
                <!-- <el-button
                  :disabled="scope.row.score === undefined || cope.row.score === null"
                  type="text"
                  size="small"
                  >答题详情</el-button
                > -->
                <!-- <el-button
                  type="text"
                  size="small"
                  @click="generateScoreSearchCode(scope.row)"
                  >生成查询码</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 修改线上成绩的dialog -->
    <el-dialog
      title="设置国赛晋级"
      :visible.sync="editScoreDialogVisible"
      @close="editScoreDialogClose"
      width="30%"
    >
      <el-form
        :model="editScoreForm"
        label-width="80px"
        ref="editScoreFormRef"
        :rules="editScoreFormRules"
      >
        <el-form-item label="姓名" prop="userName">
          <el-input
            v-model="editScoreForm.userName"
            placeholder="请输入"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="晋级资格" prop="promotion">
          <el-radio-group v-model="editScoreForm.promotion">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editScoreDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editScore">修 改</el-button>
      </span>
    </el-dialog>
    <!-- 修改线下成绩的dialog -->
    <el-dialog
      title="修改成绩信息"
      :visible.sync="editofflineScoreDialogVisible"
      @close="editoffLineScoreDialogClose"
      width="30%"
    >
      <el-form
        :model="editOffScoreForm"
        label-width="80px"
        ref="editOffScoreFormRef"
        :rules="editScoreFormRules"
      >
        <el-form-item label="姓名" prop="userName">
          <el-input
            v-model="editOffScoreForm.userName"
            placeholder="请输入"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="晋级资格" prop="promotion">
          <el-radio-group v-model="editOffScoreForm.promotion">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editofflineScoreDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="editOffScore">修 改</el-button>
      </span>
    </el-dialog>
    <!-- 批量导入线下成绩 -->
    <el-dialog
      title="批量导入"
      :visible.sync="importScoreDialogVisible"
      @close="importScoreDialogClose"
      width="30%"
    >
      <!-- <el-form
        :model="queryForm"
        label-width="100px"
        ref="editInfoFormRef"
        :rules="importScoreInfoRules"
        style="width: 100%"
      >
        <el-form-item label="学校省市区" prop="schoolArea">
          <el-cascader
            placeholder="请选择"
            v-model="queryForm.schoolArea"
            :options="areasData"
            style="width: 100%"
            :props="{
              expandTrigger: 'hover',
              label: 'name',
              value: 'id',
              children: 'areas',
            }"
            @change="provincesHandleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="学校名称" prop="schoolId">
          <el-select
            ref="schoolSelectRef"
            placeholder="请选择"
            style="width: 100%"
            v-model="queryForm.schoolId"
            @change="selectSchoolChange"
          >
            <el-option
              v-for="item in provincesSchoolList"
              :key="item.id"
              :label="item.schoolName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form> -->
      <div>
        <p>1、根据需求按筛选条件搜索并导出成绩</p>
        <p>2、在导出Excel中修改<span style="color: red;">晋级状态</span></p>
        <p>3、点击下方按钮选取文件</p>
        <p>4、确认无误后，点击确认上传</p>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-upload
        :action="scoreImportInfo.uploadUrl"
        ref="scoreImportInfoRef"
        :data="{
          season: this.queryForm.season,
          activityType: this.$chnEngStatusCode.activityType,
          raceSchedule: this.queryForm.raceSchedule,
        }"
        :headers="scoreImportInfo.headerObj"
        :on-progress="scoreImportInfoProgress"
        :on-success="scoreImportInfoSuccess"
        :on-error="scoreImportInfoError"
        :on-exceed="scoreImportInfoExceed"
        :limit="1"
        :auto-upload="false"
        :on-change="onChangeLoad"
      >
        <el-button slot="trigger" type="primary"
          >选取文件</el-button
        >
        <!-- <el-button
          style="margin-left: 10px"
          type="primary"
          size="small"
          @click="downLoadscoreImportInfoStencil"
          >下载模版</el-button
        > -->
        <el-button
          style="margin-left: 10px"
          type="success"
          @click="submitscoreImportInfo"
          >确认上传</el-button
        >
        <!-- <el-button
          style="margin-left: 10px"
          size="small"
          type="danger"
          @click="coverscoreImportInfo"
          >覆盖报名信息</el-button
        > -->
      </el-upload>
      </span>
    </el-dialog>
    <!-- 批量设置晋级dialog -->
    <el-dialog
      title="批量设置晋级"
      :visible.sync="setPassDialogVisible"
      width="30%"
      @close="setPassDialogClose"
    >
      <el-form
        ref="setPassFormRef"
        :model="setPassForm"
        :rules="setPassFormRules"
        label-width="120px"
      >
        <el-form-item label="设置范围" prop="setRange">
          <el-select
            placeholder="请选择"
            style="width: 100%"
            v-model="setPassForm.setRange"
          >
            <el-option
              v-for="item in dict_setPassRange"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictValue"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="赛区名称"
          prop="zoneId"
          v-if="setPassForm.setRange === 0"
        >
          <el-select
            placeholder="请选择"
            style="width: 100%"
            v-model="setPassForm.zoneId"
          >
            <el-option
              v-for="item in dict_district"
              :key="item.id"
              :label="item.districtName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="学校地区"
          prop="schoolArea"
          v-if="setPassForm.setRange === 1"
        >
          <el-cascader
            placeholder="请选择"
            style="width: 100%"
            v-model="setPassForm.schoolArea"
            :options="areasData"
            :props="{
              expandTrigger: 'hover',
              label: 'name',
              value: 'id',
              children: 'areas',
            }"
            @change="provincesHandleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="学校名称"
          prop="schoolId"
          v-if="setPassForm.setRange === 1"
        >
          <el-select
            placeholder="请选择"
            style="width: 100%"
            v-model="setPassForm.schoolId"
          >
            <el-option
              v-for="item in provincesSchoolList"
              :key="item.id"
              :label="item.schoolName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="年级" prop="grade" v-if="setPassForm.setRange === 1">
          <el-select
            placeholder="请选择（默认全部）"
            style="width: 100%"
            v-model="queryForm.grade"
          >
            <el-option
              v-for="item in dict_grade"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="班级"
          prop="classroom"
          v-if="setPassForm.setRange === 1"
        >
          <el-select
            placeholder="请选择（默认全部）"
            style="width: 100%"
            v-model="queryForm.classroom"
          >
            <el-option
              v-for="item in dict_classroom"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="晋级方式" prop="wayOfPromotion">
          <el-select
            placeholder="请选择"
            style="width: 100%"
            v-model="setPassForm.wayOfPromotion"
          >
            <el-option
              v-for="item in dict_setPassWay"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置值" prop="value">
          <el-input
            v-model="setPassForm.value"
            placeholder="请输入"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="参赛人数" prop="numberCompetition">
          <el-input
            v-model="setPassForm.numberCompetition"
            placeholder="请点击查看晋级预期"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="预期晋级人数" prop="expectNumber">
          <el-input
            v-model="setPassForm.expectNumber"
            placeholder="请点击查看晋级预期"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="预期晋级分数线" prop="expectLine" v-if="setPassForm.wayOfPromotion === 1">
          <el-input
            v-model="setPassForm.expectLine"
            placeholder="请点击查看晋级预期"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="预期晋级比例" prop="promotionRatio">
          <el-input
            v-model="setPassForm.promotionRatio"
            placeholder="请点击查看晋级预期"
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setPassDialogVisible = false">取 消</el-button>
        <el-button type="warning" @click="queryPromotionExpectations"
          >查看晋级预期</el-button
        >
        <el-button type="primary" @click="setPass()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择生成code方式的dialog -->
    <el-dialog
      title="选择生成方式"
      :visible.sync="scoreQueryCodeDialogVisible"
      @close="scoreQueryCodeDialogClose"
      width="35%"
    >
      <el-form
        :model="scoreQueryForm"
        :rules="scoreQueryFormRules"
        class="filter_Form"
        label-width="100px"
        ref="scoreQueryFormRef"
      >
        <el-form-item label="赛季" prop="season">
          <el-select
            placeholder="请选择赛季"
            style="width: 100%"
            v-model="scoreQueryForm.season"
          >
            <el-option
              v-for="item in dict_season"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校省市区" prop="schoolArea">
          <el-cascader
            placeholder="请选择"
            v-model="scoreQueryForm.schoolArea"
            ref="schoolAreaRef"
            :options="areasData"
            style="width: 100%"
            :props="{
              expandTrigger: 'hover',
              label: 'name',
              value: 'id',
              children: 'areas',
            }"
            @change="provincesHandleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="学校" prop="schoolId">
          <el-select
            style="width: 100%"
            placeholder="请选择"
            v-model="scoreQueryForm.schoolId"
            clearable
            filterable
          >
            <el-option
              v-for="item in provincesSchoolList"
              :key="item.id"
              :label="item.schoolName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scoreQueryCodeDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="generateScoreQueryCode"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import env from '@/http/env'
import { oneGenerateScoreCode, queryModelPaperResultScore, queryModelInitialReplyScore, queryModelExpectInitialReplyScore, getSchoolListWithCity, setTbEnrollmentPromotion, setFinalsPromotion, querySeasonRaceScheduleFlag, queryModelPaperExpectResultScore, oneKeyGenerateScoreCode, queryDistrictPage } from '@/http/api'
import areasData from '@/assets/area.json'
export default {
  data () {
    return {
      scoreQueryCodeDialogVisible: false,
      singleScoreQueryCodeDialogVisible: false,
      batchScoreQueryCodeDialogVisible: false,
      setPassDialogVisible: false,
      scoreQueryForm: {
        raceSchedule: '2',
        schoolId: '',
        season: ''
      },
      setPassForm: {
        raceSchedule: '2',
        season: this.$chnEngStatusCode.defaultSeason,
        setRange: null,
        value: '',
        wayOfPromotion: null,
        schoolId: '',
        zoneId: '',
        expectLine: '',
        promotionRatio: '',
        expectNumber: '',
        numberCompetition: ''
      },
      dict_setPassRange: [
        {
          dictCode: 0,
          dictLabel: '赛区',
          dictValue: 0,
          disabled: true
        },
        {
          dictCode: 1,
          dictLabel: '学校',
          dictValue: 1
        }
      ],
      dict_setPassWay: [
        {
          dictCode: 0,
          dictLabel: '人数',
          dictValue: 0
        },
        {
          dictCode: 2,
          dictLabel: '分数线',
          dictValue: 1
        }
      ],
      setPassFormRules: {
        wayOfPromotion: [{ required: true, message: '请选择', trigger: 'change' }],
        setRange: [{ required: true, message: '请选择', trigger: 'change' }],
        value: [{ required: true, message: '请输入', trigger: 'blur' }],
        zoneId: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolArea: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolId: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      scoreQueryFormRules: {
        season: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolArea: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolId: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      importScoreInfoRules: {
        schoolArea: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolId: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      editofflineScoreDialogVisible: false,
      isUploadFile: false, // 是否已选择上传文件
      importScoreDialogVisible: false,
      scoreImportInfo: {
        uploadUrl: env.baseIP + 'Initial/Reply/importPreliminaryCompetitionExcel',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      },
      scoreTypeActiveName: 'on-line',
      dataList: [],
      dataListOffLine: [],
      provincesSchoolList: [],
      p_open_type: this.$userInfo.getDataList(this, 'p_open_type').then(value => { this.p_open_type = value }),
      // dict_district: this.$userInfo.getDataList(this, 't_district').then(value => { this.dict_district = value }),
      dict_district: [],
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_Group: this.$userInfo.dict_group(),
      areasData: areasData.areas,
      participation_way: this.$userInfo.participation_way(),
      isPromotion: this.$userInfo.isPromotion(),
      dict_grade: this.$userInfo.getGradeData(),
      total: 0,
      editScoreDialogVisible: false,
      editScoreFormRules: {
        promotion: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      editScoreForm: {
        activityType: this.$chnEngStatusCode.activityType,
        raceSchedule: null,
        season: this.$chnEngStatusCode.defaultSeason,
        userId: '',
        promotion: null
      },
      editOffScoreForm: {
      },
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        raceSchedule: '2',
        promotion: '',
        phone: '',
        userName: '',
        season: this.$chnEngStatusCode.defaultSeason,
        districtIds: [],
        schoolId: '',
        pageNum: 1,
        pageSize: 10,
        enrollmentLevel: ''
      },
      raceScheduleList: [],
      loading: false,
      schoolName: '',
      schools: []
    }
  },
  created () {
    if (this.$route.query.l) {
      this.queryForm.enrollmentLevel = this.$route.query.l
    }
    this.seasonHandleChange()
    this.getDistrictList()
  },
  methods: {
    remoteMethod (query) {
      console.log(query)
      this.schoolName = query
      if (query !== '') {
        this.loading = true
        this.getAllSchools()
      } else {
        this.schools = []
      }
    },
    getAllSchools () {
      this.$http.get('/school/getSysSchoolList', { params: { pageSize: 10000, pageNum: 1, schoolName: this.schoolName } }).then(res => {
        if (res.code === 200) {
          this.loading = false
          this.schools = res.data.list
        }
      })
    },
    goBack () {
      this.$router.back()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 重置搜索条件
    reset () {
      this.queryForm.pageNum = 1
      this.$refs.queryFormRef.resetFields()
      this.schools = []
      this.getDataList(this.scoreTypeActiveName, '')
    },
    // 赛季选择事件回调
    seasonHandleChange (value) {
      console.log(value)
      if (value === '2022~2023') {
        this.scoreTypeActiveName = 'off-line'
      }
      var seasonStr = ''
      if (!value) {
        seasonStr = this.queryForm.season
      } else {
        seasonStr = value
      }
      var formData = {
        activityType: this.$chnEngStatusCode.activityType,
        season: seasonStr,
        scheduleFlag: this.$route.query.scheduleFlag
      }
      this.searchScheduleWithFlag(formData)
    },
    // 根据赛季标识符查询赛程相关
    searchScheduleWithFlag (formData) {
      querySeasonRaceScheduleFlag(formData).then((res) => {
        this.queryForm.raceSchedule = res.data.id
        this.getDataList(this.scoreTypeActiveName, '')
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 赛程选择
    changeRaceScheduleValue (state) {
      console.log(state)
      if (state === true && this.queryForm.season === '') {
        this.$message.error('请先选择赛季')
      }
    },
    // 学校省市区选择
    provincesHandleChange (value) {
      console.log('value', value)
      if (!value) return
      this.provincesSchoolList = []
      this.queryForm.schoolId = ''
      this.scoreQueryForm.schoolId = ''
      this.getSchoolListData(value)
    },
    // 获取学校List
    getSchoolListData (schoolArea) {
      getSchoolListWithCity({ provinceCode: schoolArea[0], cityCode: schoolArea[1], areaCode: schoolArea[2] }).then((res) => {
        console.log('getSchoolList', res)
        this.provincesSchoolList = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList(this.scoreTypeActiveName, '')
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList(this.scoreTypeActiveName, '')
    },
    // 线上、线下成绩切换
    scoreTypeChengeClick (tab, event) {
      console.log('scoreTypeActiveName', this.scoreTypeActiveName)
      this.getDataList(this.scoreTypeActiveName, 'search')
    },
    // 获取列表信息
    getDataList (scoreType, getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      if (scoreType === 'on-line') {
        this.$http.get('/Initial/Reply/queryFormAnswerResultsPage', { params: this.queryForm }).then(res => {
          if (res.code === 200) {
            this.dataList = res.data.list
            this.total = res.data.total
          }
        })
        // queryAnswerResultsPage(this.queryForm).then((res) => {
        //   console.log('queryAnswerResultsPage', res)
        //   this.dataList = res.data.list
        //   this.total = res.data.total
        // }).catch((err) => {
        //   console.log('err', err)
        // })
      } else if (scoreType === 'off-line') {
        // this.queryForm.scoreName = this.queryForm.userName
        // queryOfflineScores({ ...this.queryForm, ...{ isOnline: 0 } }).then((res) => {
        //   // console.log('queryOfflineScores', res)
        //   this.dataList = res.data.list
        //   this.total = res.data.total
        // }).catch((err) => {
        //   console.log('err', err)
        // })
        const params = { ...this.queryForm, ...{ isOnline: 0 } }
        this.$http.get('/enrollment/queryOfflineRoundScores', { params }).then(res => {
          if (res.code === 200) {
            this.dataListOffLine = res.data.list
            this.total = res.data.total
          }
        })
      }
    },
    // 显示修改晋级弹窗
    showEditDialog (row) {
      console.log('row', row)
      this.editScoreForm.userName = row.userName
      this.editScoreForm.raceSchedule = row.raceSchedule
      this.editScoreForm.userId = row.userId ? row.userId : row.id
      this.editScoreForm.promotion = row.promotion
      this.editScoreDialogVisible = true
    },
    // 单个修改线上成绩
    editScore () {
      this.savePromotionInfoData(this.editScoreForm)
    },
    // 修改成绩弹窗关闭
    editScoreDialogClose () {
      this.$refs.editScoreFormRef.resetFields()
    },
    // 显示修改线上成绩弹窗
    showEditOffLineDialog (data) {
      this.editOffScoreForm = JSON.parse(JSON.stringify(data))
      this.editofflineScoreDialogVisible = true
    },
    // 提交修改线下成绩
    editOffScore () {
      this.saveOfflinePromotionInfoData(this.editOffScoreForm)
    },
    // 修改线下成绩弹窗关闭
    editoffLineScoreDialogClose () {
      this.$refs.editOffScoreFormRef.resetFields()
    },
    // 线下导入成绩学校选择
    selectSchoolChange (e) {
      console.log('e__', e)
      this.$nextTick(function () {
        this.queryForm.schoolName = this.$refs.schoolSelectRef.selectedLabel
      })
    },
    // 提交线下成绩
    async saveOfflinePromotionInfoData (formData) {
      const data = {
        activityType: formData.activityType,
        promotion: formData.promotion,
        raceSchedule: formData.raceSchedule,
        season: formData.season,
        userId: formData.userId
      }
      console.log(data)
      setFinalsPromotion(data).then((res) => {
        this.editofflineScoreDialogVisible = false
        this.$message.success('修改成功')
        this.getDataList(this.scoreTypeActiveName, 'search')
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 提交线上成绩
    async savePromotionInfoData (formData) {
      setTbEnrollmentPromotion(formData).then((res) => {
        this.editScoreDialogVisible = false
        this.$message.success('修改成功')
        this.getDataList(this.scoreTypeActiveName, 'search')
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 上传成绩加载
    scoreImportInfoProgress () {
      this.$curUtils.openLoading(this)
    },
    // 批量上传成功
    scoreImportInfoSuccess (res) {
      this.$curUtils.closeLoading(this)
      this.$refs.scoreImportInfoRef.clearFiles()// 清除文件
      this.isUploadFile = false
      if (res.code !== 200) {
        return this.$alert('请修改后再上传，失败原因:' + '<br/>' + res.msg, '上传失败', {
          confirmButtonText: '确定',
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
      }
      this.$message.success('批量设置晋级成功')
      this.getDataList(this.scoreTypeActiveName, '')
      this.importScoreDialogVisible = false
    },
    scoreImportInfoError (error, file, fileList) {
      console.log('batchImportInfoError', error, file, fileList)
      this.$curUtils.closeLoading()
      this.$message.error(error)
    },
    scoreImportInfoExceed (files, fileList) {
      console.log('fileList', files, fileList)
      this.$set(fileList[0], 'raw', files[0])
      this.$set(fileList[0], 'name', files[0].name)
      this.$refs.scoreImportInfoRef.clearFiles()// 清除文件
      this.$refs.scoreImportInfoRef.handleStart(files[0])// 选择文件后的赋值方法
    },
    // 新增成绩
    submitscoreImportInfo () {
      // console.log('selectedLabel___________', this.$refs.schoolSelectRef.selectedLabel)
      // this.scoreImportInfo.uploadUrl = env.baseIP + 'Initial/Reply/importPreliminaryCompetitionExcel'

      if (this.scoreTypeActiveName === 'off-line') {
        this.scoreImportInfo.uploadUrl = env.baseIP + 'enrollment/toLeadIntoOfflineScores'
      } else {
        this.scoreImportInfo.uploadUrl = env.baseIP + 'Initial/Reply/importFormAnswerResults'
      }

      this.$nextTick(function () {
        // this.queryForm.schoolName = this.$refs.schoolSelectRef.selectedLabel
        // this.$refs.editInfoFormRef.validate(async valid => {
        // if (!valid) return
        // console.log('this.queryForm', this.queryForm)
        if (this.isUploadFile === true) {
          this.$refs.scoreImportInfoRef.submit()
        } else {
          this.$message.error('请先选择要上传的文件')
        }
        // })
      })
    },
    // 覆盖成绩
    coverscoreImportInfo () {
      this.scoreImportInfo.uploadUrl = env.baseIP + 'Initial/Reply/updatePreliminaryCompetitionExcel'
      this.queryForm.schoolName = this.$refs.schoolSelectRef.selectedLabel
      this.$refs.editInfoFormRef.validate(async valid => {
        if (!valid) return
        console.log('this.queryForm', this.queryForm)
        if (this.isUploadFile === true) {
          this.$confirm('是否继续覆盖该条件下的所有成绩?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            this.$refs.scoreImportInfoRef.submit()
          }).catch(() => {})
        } else {
          this.$message.error('请先选择要上传的文件')
        }
      })
    },
    // 监听上传文件弹窗关闭事件
    importScoreDialogClose () {
      // this.$refs.editInfoFormRef.clearFiles()
      this.$refs.scoreImportInfoRef.clearFiles()// 清除文件
      this.isUploadFile = false
    },
    // 下载模板
    async downLoadscoreImportInfoStencil () {
      // var downLoadUrl = env.baseIP + 'Initial/Reply/importPreliminaryCompetitionTemplate'
      this.$refs.editInfoFormRef.validate(async valid => {
        if (!valid) return
        const data = {
          activityType: this.$chnEngStatusCode.activityType,
          isOnline: 0,
          raceSchedule: this.queryForm.raceSchedule,
          season: this.queryForm.season,
          schoolId: this.queryForm.schoolId
        }
        var downLoadUrl = `${env.baseIP}enrollment/excelOfflineScores?${this.$xcUtils.serialize(data)}`
        console.log('downLoadUrl', downLoadUrl)
        this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, {})
      })
    },
    // 选择文件修改状态
    onChangeLoad (files, fileList) {
      if (fileList.length > 0) {
        this.isUploadFile = true
      }
    },
    // 查看晋级预期
    queryPromotionExpectations () {
      console.log('aaaaaa')
      this.$refs.setPassFormRef.validate(async valid => {
        console.log('valid', valid)
        if (!valid) return
        var formData = {
          raceSchedule: this.queryForm.raceSchedule,
          season: this.setPassForm.season,
          setRange: this.setPassForm.setRange,
          value: this.setPassForm.value,
          wayOfPromotion: this.setPassForm.wayOfPromotion,
          schoolId: this.setPassForm.schoolId,
          zoneId: this.setPassForm.zoneId,
          isOnline: 0
        }
        if (this.scoreTypeActiveName === 'on-line') { // 查看线上晋级预期
          queryModelPaperExpectResultScore(formData).then((res) => {
            this.setPassForm.numberCompetition = res.data.numberCompetition
            this.setPassForm.expectNumber = res.data.expectNumber
            this.setPassForm.expectLine = res.data.expectLine
            this.setPassForm.promotionRatio = res.data.promotionRatio
          }).catch((err) => {
            console.log('返回的err', err)
          })
        } else { // 查看线下晋级预期
          queryModelExpectInitialReplyScore(formData).then((res) => {
            this.setPassForm.numberCompetition = res.data.numberCompetition
            this.setPassForm.expectNumber = res.data.expectNumber
            this.setPassForm.expectLine = res.data.expectLine
            this.setPassForm.promotionRatio = res.data.promotionRatio
          }).catch((err) => {
            console.log('返回的err', err)
          })
        }
      })
    },
    setPass () {
      this.$confirm('晋级结果将以晋级预期情况来设置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$refs.setPassFormRef.validate(async valid => {
          if (!valid) return
          if (this.scoreTypeActiveName === 'on-line') { // 设置线上晋级
            this.setPassForm.raceSchedule = this.queryForm.raceSchedule
            queryModelPaperResultScore(this.setPassForm, ...{ isOnline: 1 }).then((res) => {
              console.log('queryModelPaperResultScore', res)
              this.setPassDialogVisible = false
              this.$message.success('设置成功')
              this.getDataList(this.scoreTypeActiveName, '')
            }).catch((err) => {
              console.log('err', err)
            })
          } else { // 设置线下晋级
            this.setPassForm.raceSchedule = this.queryForm.raceSchedule
            queryModelInitialReplyScore({ ...this.setPassForm, ...{ isOnline: 0 } }).then((res) => {
              console.log('queryModelPaperResultScore', res)
              this.setPassDialogVisible = false
              this.$message.success('设置成功')
              this.getDataList(this.scoreTypeActiveName, '')
            }).catch((err) => {
              console.log('err', err)
            })
          }
        })
      }).catch(() => {})
    },
    // 批量设置晋级弹窗关闭
    setPassDialogClose () {
      this.setPassSchoolList = []
      this.$refs.setPassFormRef.resetFields()
    },
    // 生成成绩查询码
    generateScoreQueryCode () {
      this.$refs.scoreQueryFormRef.validate(async valid => {
        if (!valid) return
        oneKeyGenerateScoreCode(this.scoreQueryForm).then((res) => {
          this.scoreQueryCodeDialogVisible = false
          this.$message.success('生成成功')
          this.getDataList(this.scoreTypeActiveName, '')
        }).catch((err) => {
          console.log('返回的err', err)
        })
      })
    },
    // 成绩查询码弹窗关闭
    scoreQueryCodeDialogClose () {
      this.$refs.scoreQueryFormRef.resetFields()
    },
    // 单个生成成绩查询码
    generateScoreSearchCode (rowData) {
      this.$confirm('是否确认生成该考生成绩查询码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        oneGenerateScoreCode({ id: rowData.id }).then((res) => {
          console.log('oneGenerateScoreCode', res)
          this.$message.success('生成成功')
          this.getDataList(this.scoreTypeActiveName, '')
        }).catch((err) => {
          console.log('err', err)
        })
      }).catch(() => {})
    },
    // 导出成绩查询码
    downLoadScoreSearchCode () {
      var downLoadUrl = env.baseIP + 'Initial/Reply/excelPaperResultScoreCode'
      console.log('downLoadUrl', downLoadUrl)
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, this.queryForm)
    },
    gradeFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_grade) {
        if (Object.hasOwnProperty.call(this.dict_grade, key)) {
          const element = this.dict_grade[key]
          if (data.scoreGrade) {
            if (element.dictValue === data.scoreGrade + '') {
              temp = element.dictLabel
            }
          }
          if (data.grade) {
            if (element.dictValue === data.grade + '') {
              temp = element.dictLabel
            }
          }
        }
      }
      return temp
    },
    gradeFormatter2 (data) {
      var temp = '未知'
      for (const key in this.dict_grade) {
        if (Object.hasOwnProperty.call(this.dict_grade, key)) {
          const element = this.dict_grade[key]
          if (data.grade) {
            if (element.dictValue === data.grade + '') {
              temp = element.dictLabel
            }
          }
          if (data.grade) {
            if (element.dictValue === data.grade + '') {
              temp = element.dictLabel
            }
          }
        }
      }
      return temp
    },
    groupFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_Group) {
        if (Object.hasOwnProperty.call(this.dict_Group, key)) {
          const element = this.dict_Group[key]
          if (element.dictValue === data.enrollmentLevel + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    scoreFormat (score) {
      return score === undefined || score === null ? '--' : score
    },
    // 组别
    gradeGroupFormatter (data) {
      return this.dict_Group.find(item => item.dictCode === data.enrollmentLevel).dictLabel
      // var gradeData = this.dict_Group(data.enrollmentLevel)
      // return gradeData.userGradeStr
    },
    participationFormatter (data) {
      var temp = '未知'
      for (const key in this.participation_way) {
        if (Object.hasOwnProperty.call(this.participation_way, key)) {
          const element = this.participation_way[key]
          if (element.dictValue === data.grade + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    // 导出名单
    exportFn () {
      console.log(this.queryForm)
      const { activityType, raceSchedule, season, schoolId, enrollmentLevel, phone, promotion, userName, districtIds } = this.queryForm
      const url = this.scoreTypeActiveName === 'off-line' ? 'enrollment/excelOfflineScores' : 'Initial/Reply/exportFormAnswerResults'
      const downLoadUrl = `${this.$http.defaults.baseURL}${url}?${this.$xcUtils.serialize({ activityType, raceSchedule, season, schoolId, enrollmentLevel, phone, promotion, userName, isOnline: 0, districtIds })}`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },
    handleToFormScores () {
      this.$router.push({
        path: '/examination_Management/fas',
        query: {
          season: '2022~2023'
        }
      })
    },
    // 查看答题详情
    showViewDetails (rowData) {
      var formData = {
        season: this.queryForm.season,
        activityType: this.$chnEngStatusCode.activityType,
        raceSchedule: this.queryForm.raceSchedule,
        userId: rowData.userId
      }
      var formData2 = {
        matchResultId: rowData.matchResultId,
        season: this.queryForm.season,
        userName: rowData.userName,
        score: rowData.score
      }
      this.$router.push(
        {
          path: '/schedule_Childview/individual_answer_result',
          query: {
            formDataStr: this.queryForm.season === '2022~2023' ? JSON.stringify(formData) : JSON.stringify(formData2)
          }
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.title_class {
  display: -moz-inline-box;
  display: inline-block;
  width: 120px;
}
.score-querytype-class {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.score{
  color: #409EFF;
  font-size: 16px;
}
.text-btn{
  float: right;
  color: #409EFF;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  text-decoration: underline;
}

</style>
